export function discountDuration(discount) {
  switch (discount.type) {
    case 'percent':
      return discount.duration === 0 ? null : `${discount.duration} months`;
    case 'fixed':
      return null;
  }
}

export function discountAmount(discount) {
  switch (discount.type) {
    case 'percent':
      return `${discount.percent}%`;
    case 'fixed':
      return `$${discount.amount}`;
  }
}

export const PENDING_CONVERSION_STATUSES = ['pending', 'trialing'];
